<app-floorplan-custom-part-numbers [floorplanItem]="signalElement()"></app-floorplan-custom-part-numbers>
